export const galleryTypes = {
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    SET_CATEGORIA: 'SET_CATEGORIA',
    SET_RUBRO: 'SET_RUBRO',
    SET_SUBRUBRO: 'SET_SUBRUBRO',
    SET_PROMOCION: 'SET_PROMOCION',
};